var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 148,
    viewBox: "0 0 200 148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Empty",
    transform: "translate(-1048 -616)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150005",
    "data-name": "Rectangle 150005",
    width: 200,
    height: 148,
    transform: "translate(1048 616)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "undraw_no_data_re_kwbl",
    transform: "translate(1074 617.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29943",
    "data-name": "Path 29943",
    d: "M399.878,188.018H360.214a3.413,3.413,0,0,0-3.409,3.409v88.154l-.455.139-9.73,2.98a1.82,1.82,0,0,1-2.271-1.207l-28.943-94.541a1.819,1.819,0,0,1,1.207-2.271l14.994-4.591,43.469-13.305,14.994-4.591a1.816,1.816,0,0,1,2.271,1.2l7.4,24.165Z",
    transform: "translate(-306.429 -155.701)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29944",
    "data-name": "Path 29944",
    d: "M378.286,165.776l-8.917-29.125a3.862,3.862,0,0,0-4.825-2.564l-21.081,6.453L300,153.848,278.916,160.3a3.867,3.867,0,0,0-2.564,4.825l30.475,99.536a3.87,3.87,0,0,0,3.7,2.734,3.816,3.816,0,0,0,1.13-.171l14.451-4.423.455-.141v-.475l-.455.139-14.585,4.466a3.413,3.413,0,0,1-4.257-2.262l-30.473-99.539a3.4,3.4,0,0,1,2.261-4.257l21.081-6.455L343.6,140.976l21.081-6.455a3.406,3.406,0,0,1,4.257,2.262l8.876,28.993.141.455h.473Z",
    transform: "translate(-276.182 -133.913)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29945",
    "data-name": "Path 29945",
    d: "M381.949,173.693a2.049,2.049,0,0,1-1.957-1.447l-2.928-9.562a2.045,2.045,0,0,1,1.357-2.555l39.989-12.243a2.048,2.048,0,0,1,2.555,1.357l2.928,9.563a2.048,2.048,0,0,1-1.357,2.555L382.547,173.6A2.04,2.04,0,0,1,381.949,173.693Z",
    transform: "translate(-354.065 -144.638)",
    fill: "#004fe0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_525",
    "data-name": "Ellipse 525",
    cx: 4.546,
    cy: 4.546,
    r: 4.546,
    transform: "translate(38.675 1.129)",
    fill: "#004fe0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_526",
    "data-name": "Ellipse 526",
    cx: 2.879,
    cy: 2.879,
    r: 2.879,
    transform: "translate(40.342 2.796)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29946",
    "data-name": "Path 29946",
    d: "M611.073,390H534.25a1.934,1.934,0,0,1-1.932-1.932V296.019a1.934,1.934,0,0,1,1.932-1.932h76.823a1.934,1.934,0,0,1,1.932,1.932v92.052A1.934,1.934,0,0,1,611.073,390Z",
    transform: "translate(-474.101 -257.678)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29947",
    "data-name": "Path 29947",
    d: "M547.526,274.087H499.682a3.869,3.869,0,0,0-3.864,3.864v92.688l.455-.139V277.951a3.413,3.413,0,0,1,3.409-3.409h47.985Zm41.707,0H499.682a3.869,3.869,0,0,0-3.864,3.864v104.1a3.869,3.869,0,0,0,3.864,3.864h89.552a3.869,3.869,0,0,0,3.864-3.864v-104.1A3.869,3.869,0,0,0,589.233,274.087Zm3.409,107.962a3.413,3.413,0,0,1-3.409,3.409H499.682a3.413,3.413,0,0,1-3.409-3.409v-104.1a3.413,3.413,0,0,1,3.409-3.409h89.552a3.413,3.413,0,0,1,3.409,3.409Z",
    transform: "translate(-445.897 -242.224)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29948",
    "data-name": "Path 29948",
    d: "M652.685,270.179H610.864a2.048,2.048,0,0,1-2.046-2.046v-10a2.048,2.048,0,0,1,2.046-2.046h41.821a2.048,2.048,0,0,1,2.046,2.046v10a2.048,2.048,0,0,1-2.046,2.046Z",
    transform: "translate(-533.213 -228.315)",
    fill: "#004fe0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_527",
    "data-name": "Ellipse 527",
    cx: 4.546,
    cy: 4.546,
    r: 4.546,
    transform: "translate(94.015 19.362)",
    fill: "#004fe0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_528",
    "data-name": "Ellipse 528",
    cx: 2.769,
    cy: 2.769,
    r: 2.769,
    transform: "translate(95.792 21.139)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/Empty.735d1d66cfb0d79897bf6a3502455dd4.svg";
export { ForwardRef as ReactComponent };